import { useState } from 'react'

import { useAuth } from '../auth'
import { wipeLocal } from '../lib/db'
import { unlocked, vaultReady } from '../lib/vault'
import Login from '../pages/Login'
import MobileApp from './MobileApp'
import PinLock, { PinSetup, hasPin, rememberPinSet } from './PinLock'
import './mobile.css'

/**
 * Что показать на телефоне при запуске.
 *
 * Порядок важен. Замок стоит перед всем остальным, даже когда сессия ещё
 * жива: токен живёт месяц, и без замка нашедший телефон открыл бы программу
 * со всеми паролями клиентов простым запуском. Заодно ввод кода даёт ключ,
 * которым расшифровывается кэш доступов.
 */
export default function MobileGate() {
  const { user, adoptToken, logout } = useAuth()

  // «Войти паролем» с экрана кода: показываем обычную форму, код не трогаем.
  const [passwordMode, setPasswordMode] = useState(false)
  // Пропуск предложения задать код запоминаем на сеанс, чтобы не спрашивать
  // после каждого действия.
  const [pinAsked, setPinAsked] = useState(false)
  // Счётчик заставляет перерисоваться после снятия замка: ключ живёт в памяти
  // модуля, а не в состоянии React.
  const [, bump] = useState(0)

  if (vaultReady() && !unlocked() && !passwordMode) {
    return (
      <PinLock
        onUnlocked={(token) => {
          if (token) void adoptToken(token)
          else bump((n) => n + 1)
        }}
        onForget={() => setPasswordMode(true)}
      />
    )
  }

  if (!user) return <Login />

  if (!hasPin() && !pinAsked) {
    return (
      <PinSetup
        fullName={user.full_name}
        onDone={() => setPinAsked(true)}
        onSkip={() => setPinAsked(true)}
      />
    )
  }

  return (
    <MobileApp
      onLogout={async () => {
        // Выход стирает локальные данные: на телефоне лежат пароли клиентов,
        // и оставлять их после смены владельца устройства нельзя.
        await wipeLocal()
        rememberPinSet(false)
        setPinAsked(false)
        setPasswordMode(false)
        logout()
      }}
    />
  )
}
